import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  RouteRecordRaw
} from 'vue-router'
import { getToken } from '@/plugins/cookie'

export const Menu: Array<RouteRecordRaw> = [
  {
    path: '/user-info',
    name: 'UserInfo',
    meta: {
      title: '修改个人信息',
      icon: ''
    },
    component: () => import('@/views/home/UserInfo.vue')
  },
  {
    path: '/rule',
    name: 'Rule',
    meta: {
      icon: '',
      router: false
    },
    redirect: '/rule/platform/list',
    children: [
      {
        path: '/rule/platform/list',
        meta: {
          title: '规则管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/rule/platform/list',
            name: 'RulePlatformList',
            component: () => import('@/views/rule-manager/platform-manager/list.vue'),
            meta: {
              title: '平台规则',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/rule/platform/edit',
            name: 'RulePlatformEdit',
            component: () => import('@/views/rule-manager/platform-manager/edit.vue'),
            meta: {
              title: '操作规则',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      }
    ]
  },

{
    path: '/dataview',
    name: 'Dataview',
    meta: {
      icon: '',
      router: false
    },
    redirect: '/dataview/home',
    children: [
      {
        path: '/dataview/home',
        meta: {
          title: '数据看板',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/dataview/home',
            name: 'DataviewHome',
            component: () => import('@/views/dataview-manager/homeData.vue'),
            meta: {
              title: '数据看板',
              icon: '',
              menuType: 'Menu'
            }
          },
 
        ]
      }
    ]
  },
  

  {
    path: '/examine',
    name: 'Examine',
    meta: {
      icon: '',
      router: false
    },
    redirect: '/examine/config/list',
    children: [
      {
        path: '/examine/config/list',
        meta: {
          title: '审批管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/examine/config/list',
            name: 'ExamineConfigList',
            component: () => import('@/views/examine-manager/config-manager/list.vue'),
            meta: {
              title: '审批配置',
              icon: '',
              menuType: 'Menu'
            }
          }
        ]
      },
      {
        path: '/examine/initiate/list',
        meta: {
          title: '我发起的审批',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/examine/initiate/list',
            name: 'ExamineInitiateList',
            component: () => import('@/views/examine-manager/initiate-manager/list.vue'),
            meta: {
              title: '我发起的审批',
              icon: '',
              menuType: 'Menu'
            }
          }
        ]
      },
      {
        path: '/examine/task/list',
        meta: {
          title: '我的审批任务',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/examine/task/list',
            name: 'ExamineTaskList',
            component: () => import('@/views/examine-manager/task-manager/list.vue'),
            meta: {
              title: '我的审批任务',
              icon: '',
              menuType: 'Menu'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/examine',
    name: 'Examine',
    meta: {
      icon: '',
      router: false
    },
    redirect: '/marking-service/index/clue/account/list',
    children: [
      {
        path: '/marking-service/index/clue/account/list',
        meta: {
          title: '线索管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/marking-service/index/clue/account/list',
            name: 'ClueAccountList',
            component: () => import('@/views/clue-manager/account-manager/list.vue'),
            meta: {
              title: '线索账户',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/clue/account/edit',
            name: 'ClueAccountEdit',
            component: () => import('@/views/clue-manager/account-manager/edit.vue'),
            meta: {
              title: '操作线索账户',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/clue/content/list',
        meta: {
          title: '线索内容',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/clue/content/list',
            name: 'ClueContentList',
            component: () => import('@/views/clue-manager/content-manager/list.vue'),
            meta: {
              title: '线索内容',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/clue/account/edit',
            name: 'ClueAccountEdit',
            component: () => import('@/views/clue-manager/account-manager/edit.vue'),
            meta: {
              title: '操作线索账户',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
    ]
  },
  {
    path: '/label',
    name: 'Label',
    meta: {
      icon: '',
      router: false
    },
    redirect: '/label/type/list',
    children: [
      {
        path: '/label/type/list',
        meta: {
          title: '达人标签类型',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/label/type/list',
            name: 'LabelType',
            component: () => import('@/views/label-manager/type-manager/list.vue'),
            meta: {
              title: '达人标签类型',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/label/type/edit',
            name: 'TypeEdit',
            component: () => import('@/views/label-manager/type-manager/edit.vue'),
            meta: {
              title: '操作标签类型',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/label/library/list',
        meta: {
          title: '标签库',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/label/library/list',
            name: 'LabelLibrary',
            component: () => import('@/views/label-manager/library-manager/list.vue'),
            meta: {
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/label/library/edit',
            name: 'LibraryEdit',
            component: () => import('@/views/label-manager/library-manager/edit.vue'),
            meta: {
              title:'操作标签',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/label/class/list',
        meta: {
          title: '品类库',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/label/class/list',
            name: 'ClassList',
            component: () => import('@/views/label-manager/class-manager/list.vue'),
            meta: {
              title: '品类库',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/label/class/edit',
            name: 'ClassEdit',
            component: () => import('@/views/label-manager/class-manager/edit.vue'),
            meta: {
              title:'操作品类',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
    ]
  },
  {
    path: '/system',
    name: 'System',
    meta: {
      icon: '',
      router: false
    },
    redirect: '/system/staff',
    children: [
      {
        path: '/system/staff',
        name: 'StaffAdmin',
        redirect: "/system/staff/list",
        meta: {
          title: '人员管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/system/staff/list',
            name: 'StaffList',
            component: () =>
              import('@/views/system-manager/staff-manager/list.vue'),
            meta: {
              title: '人员列表',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/system/staff/edit',
            name: 'StaffEdit',
            component: () =>
              import('@/views/system-manager/staff-manager/edit.vue'),
            meta: {
              title: '人员添加编辑',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/system/staff/authority',
            name: 'Authority',
            component: () =>
              import('@/views/system-manager/staff-manager/authority.vue'),
            meta: {
              title: '设置权限',
              icon: '',
              menuType: 'Menu'
            }
          }
        ]
      },
      {
        path: '/system/role',
        name: 'RoleAdmin',
        redirect: '/system/role/list',
        meta: {
          title: '角色管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/system/role/list',
            name: 'RoleList',
            component: () =>
              import('@/views/system-manager/role-manager/list.vue'),
            meta: {
              title: '角色列表',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/system/role/edit',
            name: 'RoleEdit',
            component: () =>
              import('@/views/system-manager/role-manager/edit.vue'),
            meta: {
              title: '角色编辑修改',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/system/platform',
        name: 'Platform',
        redirect: '/system/platform/list',
        meta: {
          title: '代运营平台配置',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/system/platform/list',
            name: 'PlatformList',
            component: () =>
              import('@/views/system-manager/platform-manager/list.vue'),
            meta: {
              title: '代运营平台列表',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/system/platform/edit',
            name: 'PlatformEdit',
            component: () =>
              import('@/views/system-manager/platform-manager/edit.vue'),
            meta: {
              title: '代运营平台操作',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/system/menu',
        name: 'MenuAdmin',
        redirect: '/system/menu/list',
        meta: {
          title: '菜单管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/system/menu/list',
            name: 'MenuList',
            component: () =>
              import('@/views/system-manager/menu-manager/list.vue'),
            meta: {
              title: '菜单列表',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/system/menu/edit',
            name: 'MenuEdit',
            component: () =>
              import('@/views/system-manager/menu-manager/edit.vue'),
            meta: {
              title: '菜单操作',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/system/agency',
        name: 'AgencyAdmin',
        redirect: '/system/agency/list',
        meta: {
          title: '机构管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/system/agency/list',
            name: 'AgencyList',
            component: () =>
              import('@/views/system-manager/agency-manager/list.vue'),
            meta: {
              title: '机构管理',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/system/agency/edit',
            name: 'AgencyEdit',
            component: () =>
              import('@/views/system-manager/agency-manager/edit.vue'),
            meta: {
              title: '机构操作',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/system/account',
        name: 'AccountAdmin',
        redirect: '/system/account/list',
        meta: {
          title: '机构账号管理',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/system/account/list',
            name: 'SystemAccountList',
            component: () =>
              import('@/views/system-manager/account-manager/list.vue'),
            meta: {
              title: '机构账号管理',
              icon: '',
              menuType: 'Menu'
            }
          },
          {
            path: '/system/account/edit',
            name: 'SystemAccountEdit',
            component: () =>
              import('@/views/system-manager/account-manager/edit.vue'),
            meta: {
              title: '机构账号操作',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
      {
        path: '/system/log',
        name: 'LogAdmin',
        redirect: '/system/log/list',
        meta: {
          title: '操作日志',
          icon: '',
          menuType: 'Menu'
        },
        children: [
          {
            path: '/system/log/list',
            name: 'LogList',
            component: () =>
              import('@/views/system-manager/log-manager/list.vue'),
            meta: {
              title: '日志列表',
              icon: '',
              menuType: 'Menu'
            }
          },
        ]
      },
	  {
	    path: '/message',
	    name: 'Message',
	    redirect: '/message/list',
	    meta: {
	      title: '消息通知',
	      icon: '',
	      menuType: 'Menu'
	    },
	    children: [
	      {
	        path: '/Message/list',
	        name: 'MessageList',
	        component: () =>
	          import('@/views/message-manager/list.vue'),
	        meta: {
	          title: '全部消息',
	          icon: '',
	          menuType: 'Menu'
	        }
	      },
	    ]
	  },
	  {
	    path: '/actuator',
	    name: 'Actuator',
	    redirect: '/actuator/list',
	    meta: {
	      title: '执行器',
	      icon: '',
	      menuType: 'Menu'
	    },
	    children: [
	      {
	        path: '/actuator/list',
	        name: 'ActuatorList',
	        component: () =>
	          import('@/views/actuator-manager/list.vue'),
	        meta: {
	          title: '执行器列表',
	          icon: '',
	          menuType: 'Menu'
	        }
	      },
	    ]
	  },
    ]
  }
]

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登陆',
      icon: '',
      menuType: 'Home'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      title: '首页',
      icon: '',
      router: true
    },
    // redirect: '/marking/', // 打标
	redirect: '/home/info',
    children: [
      {
        path: '/home/info',
        name: 'HomeInfo',
        component: () => import('@/views/home/HomeInfo.vue'),
        meta: {
          title: '首页数据',
          icon: '',
          menuType: 'Home'
        }
      },
      ...Menu,
	  {
	    path: '/marking-service',
	    name: 'Marking',
	    meta: {
	      title: '打标',
	      icon: '',
	      router: true
	    },
		redirect: '/marking-service/index',
		children: [
		  {
		    path: '/marking-service/index',
		    name: 'MarkingIndex',
		    component: () => import('../views/service-manager/marking-manager/marking.vue'),
		    meta: {
		      title: '打标',
		      icon: '',
		      menuType: 'Menu'
		    }
		  },
		  {
		    path: '/marking-service/details',
		    name: 'MarkingDetails',
		    component: () => import('../views/service-manager/marking-manager/marking.vue'),
		    meta: {
		      title: '打标详情',
		      icon: '',
		      menuType: 'Menu'
		    }
		  },
		]
	  },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

const BaseTitle = '小鲸鱼运营后台'

router.beforeEach((to, from, next) => {
	console.log(111111111111111)
  document.title = (to.meta.title ? to.meta.title : BaseTitle) as string
  localStorage.setItem('moduletitle', document.title)
  const BaseWhiteList = ['Login']
  switch (true) {
    case !getToken() && !BaseWhiteList.includes(to.name as string):
      next({ name: 'Login' })
      break
    case getToken() && BaseWhiteList.includes(to.name as string):
      next({ name: 'Home' })
      break
    default:
      setTimeout(() => {
		  next()
	  }, 1000)
      break
  }
})

export default router
